import { ReactNode } from 'react';
import { Button, ButtonProps } from '@mui/material';
import LoopIcon from '@mui/icons-material/Loop';

export type LoadingButtonProps = ButtonProps & {
  loading?: boolean;
  children?: ReactNode;
};

export default function LoadingButton(props: LoadingButtonProps) {
  const { loading, disabled, ...rest } = props;
  const isButtonDisabled = loading || disabled;
  return (
    <Button {...rest} disabled={isButtonDisabled}>
      {props.loading ? (
        <LoopIcon
          sx={{
            animation: 'spin 1s linear infinite',
            '@keyframes spin': {
              '0%': {
                transform: 'rotate(360deg)',
              },
              '100%': {
                transform: 'rotate(0deg)',
              },
            },
            fontSize: props.size === 'large' ? 26 : undefined,
          }}
        />
      ) : (
        props.children
      )}
    </Button>
  );
}

export function PageLoadingButton(props: LoadingButtonProps) {
  return (
    <LoadingButton
      variant={'contained'}
      size="large"
      {...props}
      sx={(theme) => ({
        ...props.sx,
        [theme.breakpoints.up('sm')]: {
          float: 'right',
        },
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          marginBottom: '1rem',
        },
      })}
    />
  );
}

export function PageCancelButton(props: ButtonProps) {
  return (
    <Button
      {...props}
      size="large"
      variant="outlined"
      sx={(theme) => ({
        [theme.breakpoints.up('sm')]: {
          float: 'left',
          marginRight: '2rem',
        },
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          marginBottom: '1rem',
        },
        ...props.sx,
      })}
    >
      {props.children || 'Cancel'}
    </Button>
  );
}
